import React, { Component } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';

class EditProductForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: props.product.name || '',
            category: props.product.category_id || '',
            subCategory: props.product.subcategory_name || '',
            costPrice: props.product.costprice || '',
            margin: props.product.margin || '',
            stock: props.product.stock || '',
            salesPrice: props.product.salesprice || '',
            discount: props.product.discount || '',
            delivery_charges: props.product.delivery_charges || '',
            images: [],
            imagePreviewUrls: [],
            categories: [], // Initialize as empty array
            subCategories: [], // Initialize as empty array
            updateMessage: '', // State to store the success or error message
            updateStatus: null, // State to store whether the update was successful or not
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleCategoryChange = this.handleCategoryChange.bind(this);
        this.handleSubCategoryChange = this.handleSubCategoryChange.bind(this);
        this.handleImageChange = this.handleImageChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        // Fetch categories and subcategories from the API
        axios.get('https://earnistamart.online/getcategories')
            .then(response => {
                this.setState({ categories: response.data.posts });
                // Preselect the subcategories if editing a product
                const selectedCategory = response.data.posts.find(cat => cat._id === this.state.category);
                if (selectedCategory) {
                    this.setState({ subCategories: selectedCategory.subcategories });
                }
            })
            .catch(error => {
                console.error('There was an error fetching the categories!', error);
            });
    }

    handleChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    handleCategoryChange(event) {
        const selectedCategoryId = parseInt(event.target.value);
        const selectedCategory = this.state.categories.find(cat => cat._id === selectedCategoryId);

        this.setState({
            category: selectedCategoryId,
            subCategories: selectedCategory ? selectedCategory.subcategories : [],
            subCategory: '' // Reset subcategory when category changes
        });
    }

    handleSubCategoryChange(event) {
        this.setState({ subCategory: event.target.value });
    }

    handleImageChange(event) {
        let files = event.target.files;
        let imagePreviewUrls = [];
        for (let i = 0; i < files.length; i++) {
            let reader = new FileReader();
            reader.onloadend = () => {
                imagePreviewUrls.push(reader.result);
                this.setState({ imagePreviewUrls });
            };
            reader.readAsDataURL(files[i]);
        }
        this.setState({ images: files });
    }

    handleSubmit(event) {
        event.preventDefault();
        const updatedProduct = {
            name: this.state.name,
            category_id: this.state.category,
            subcategory_name: this.state.subCategory,
            costprice: this.state.costPrice,
            margin: this.state.margin,
            stock: this.state.stock,
            discount: this.state.discount,
            delivery_charges: this.state.delivery_charges,
            // Additional fields you want to include
        };

        axios.put(`https://earnistamart.online/updateproduct/${this.props.product._id}`, updatedProduct)
            .then(response => {
                this.setState({ updateMessage: 'Product updated successfully!', updateStatus: 'success' });
            })
            .catch(error => {
                this.setState({ updateMessage: 'Failed to update product.', updateStatus: 'error' });
                console.error('There was an error updating the product!', error);
            });
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                {this.state.updateMessage && (
                    <div className={`alert ${this.state.updateStatus === 'success' ? 'alert-success' : 'alert-danger'}`} role="alert">
                        {this.state.updateMessage}
                    </div>
                )}

                <div className="form-group">
                    <label htmlFor="name">Name</label>
                    <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        value={this.state.name}
                        onChange={this.handleChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="category">Category</label>
                    <select
                        className="form-control"
                        id="category"
                        name="category"
                        value={this.state.category}
                        onChange={this.handleCategoryChange}
                        required
                    >
                        <option value="" disabled>Select Category</option>
                        {this.state.categories.map(cat => (
                            <option key={cat._id} value={cat._id}>
                                {cat.name}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="form-group">
                    <label htmlFor="subCategory">Sub-Category</label>
                    <select
                        className="form-control"
                        id="subCategory"
                        name="subCategory"
                        value={this.state.subCategory}
                        onChange={this.handleSubCategoryChange}
                        required
                        disabled={!this.state.category}
                    >
                        <option value="" disabled>Select Sub-Category</option>
                        {this.state.subCategories.map((subCat, index) => (
                            <option key={index} value={subCat.name}>
                                {subCat.name}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="form-group">
                    <label htmlFor="costPrice">Cost Price</label>
                    <input
                        type="number"
                        className="form-control"
                        id="costPrice"
                        name="costPrice"
                        value={this.state.costPrice}
                        onChange={this.handleChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="margin">Margin</label>
                    <input
                        type="number"
                        className="form-control"
                        id="margin"
                        name="margin"
                        value={this.state.margin}
                        onChange={this.handleChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="stock">Stock</label>
                    <input
                        type="number"
                        className="form-control"
                        id="stock"
                        name="stock"
                        value={this.state.stock}
                        onChange={this.handleChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="salesPrice">Sales Price</label>
                    <input
                        type="text"
                        className="form-control"
                        id="salesPrice"
                        value={this.state.salesPrice}
                        readOnly
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="discount">Discount (%)</label>
                    <input
                        type="number"
                        className="form-control"
                        id="discount"
                        name="discount"
                        value={this.state.discount}
                        onChange={this.handleChange}
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="discountedPrice">Discounted Price</label>
                    <input
                        type="text"
                        className="form-control"
                        id="discountedPrice"
                        value={this.state.salesPrice - (this.state.salesPrice * (this.state.discount / 100))}
                        readOnly
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="delivery_charges">Delivery Charges</label>
                    <input
                        type="number"
                        className="form-control"
                        id="delivery_charges"
                        name="delivery_charges"
                        value={this.state.delivery_charges}
                        onChange={this.handleChange}
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="images">Product Images</label>
                    <input
                        type="file"
                        className="form-control-file"
                        id="images"
                        name="images"
                        onChange={this.handleImageChange}
                        multiple
                    />
                    <div className="row mt-2">
                        {this.state.imagePreviewUrls.map((url, index) => (
                            <div key={index} className="col-md-3">
                                <img
                                    src={url}
                                    alt={`Preview ${index + 1}`}
                                    className="img-thumbnail"
                                />
                            </div>
                        ))}
                    </div>
                </div>

                <button type="submit" className="btn btn-primary btn-block mt-4">
                    Update Product
                </button>
            </form>
        );
    }
}

export default EditProductForm;
